export const data = [
  {
    id: 1,
    question: 'ХОТИМ ПОИГРАТЬ У ВАС, ЧТО НАМ ДЕЛАТЬ?',
    answer:
      'Вам нужно зарание забронировать игру. Это можно сделать просто позвонив по телефону +7-843-258-74-27 или оставить заявку и наш менеджер перезвонит вам.',
  },
  {
    id: 2,
    question: 'КАК ПРОХОДЯТ ИГРЫ?',
    answer:
      'Вы приезжаете на полигон за 15-20 минут до начала. Располагаетесь в зоне отдыха. Далее проводится инструктаж. Потом начинается игра по различным сценариям. Между играми делаются небольшие перерывы.',
  },
  {
    id: 3,
    question: 'ЧТО ЛУЧШЕ НАДЕТЬ?',
    answer: 'Удобную обувь и одежду, игра активная.',
  },
  {
    id: 4,
    question: 'МОЖНО ЛИ ПРИНОСИТЬ СВОЮ ЕДУ?',
    answer: 'Да, вы можете принести свою еду, а также заказать доставку.',
  },
  {
    id: 5,
    question: 'ПРОВОДИТЕ ЛИ ВЫ ВЫЕЗДНЫЕ ИГРЫ?',
    answer:
      'Да, проводим. Мы можем приехать на любую площадку в пределах города. На базу отдыха или другое место по вашему выбору. Цена раcсчитывается индивидуально.',
  },
  // {
  //   id: 6,
  //   question: 'ЛАЗЕРТАГ БЕЗОПАСЕН?',
  //   answer:
  //     'Конечно! Игра бесконтактная, а инфракрасное излучение, на котором основан лазертаг, абсолютно безопасно, что позволяет играть даже самым маленьким.',
  // },
];
